export enum AiChatContextEnum {
    documents = 'documents',
    vaults = 'vaults',
    organisation = 'organisation',
}
